@if (button) {
    <ion-button (click)="onButtonClick()" class="button-unstyled ion-margin-bottom">
        <ng-content *ngTemplateOutlet="card"></ng-content>
        <div class="ion-activatable full-width full-height position-absolute-center">
            <ion-ripple-effect></ion-ripple-effect>
        </div>
    </ion-button>
} @else {
    <ng-content *ngTemplateOutlet="card"></ng-content>
}

<ng-template #card>
    <ion-card
        class="card card-{{ type }} {{ class }}"
        [ngClass]="{ 'ion-no-margin': noMargin, 'card-border': borders }">
        <ng-container *ngIf="type === 'strong'">
            <div class="card-bg-decoration">
                <img src="../../../assets/svgs/decoration-lattice.svg" />
            </div>
        </ng-container>
        <ion-card-header #header>
            <ng-content select="[header]"></ng-content>
        </ion-card-header>
        <ion-card-content>
            <ng-content></ng-content>
        </ion-card-content>
    </ion-card>
</ng-template>
